import {Pipe, PipeTransform} from '@angular/core';

// Formats an instant in DST-aware Eastern time, matching DATE_TIME_FORMAT
// ('dd-MM-yyyy, h:mm a'), e.g. "25-06-2026, 6:00 PM". Angular's date pipe can't do
// DST-aware zones (its 'EST' is a fixed -05:00), so we use Intl.DateTimeFormat.
@Pipe({
    name: 'easternTime',
    standalone: true
})
export class EasternTimePipe implements PipeTransform {
    transform(value: Date | string | number | undefined | null): string {
        if (!value) return '';

        const date = value instanceof Date ? value : new Date(value);
        if (isNaN(date.getTime())) return '';

        const parts = new Intl.DateTimeFormat('en-US', {
            timeZone: 'America/Toronto', // IANA Eastern zone — DST-aware (EST -05:00 in winter, EDT -04:00 in summer).
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true
        }).formatToParts(date);

        const get = (type: string) => parts.find(p => p.type === type)?.value ?? '';

        return `${get('day')}-${get('month')}-${get('year')}, ${get('hour')}:${get('minute')} ${get('dayPeriod')}`;
    }
}
